import { ca } from '@cian/analytics';

export const VIEWED_TIMEOUT = 1000;

type TBannerType = 'dailyRent';

export const tackShowDailyRentBanner = (bannerType: TBannerType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Show',
    label: 'InformBanner',
    page: {
      extra: {
        banner_type: bannerType,
      },
    },
    useLastProducts: true,
  });
};
